<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading">保存</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
    <div>
      <vgtree ref="xTree" :list="list" tableheight="700" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needRowNum="true" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
              @cellClick="cellClick" @getxTree="getxTree">
      </vgtree>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree'
  export default {
    name: "comMenuform",
    data () {
      return {
        com: this.$route.params.form,
        type: Number(this.$route.params.type),
        btnLoading: false,
        menuList: [],
        list: [],
        commenus: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80,treeNode:'true'},
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'menuname', fieldtype: 'C', title: '菜单名称',calculExpr:'',addNewRowFlg: false}
        ],
      }
    },
    activated() {
      this.init()
      this.getPageList()
    },
    created () {
    },
    watch: {
    },
    filters: {
    },
    components: {vgtree},
    methods: {
      async init() {
        this.com = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.menuList = []
        this.list = []
        this.commenus = []
      },
      async save () {
        let selectRecords = this.$refs.xTree.$refs.xTree.getSelectRecords()
        let model = {
          insertRecords:selectRecords,
          com: this.com
        }
        console.log(selectRecords)
        this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/ywgl/expert/saveExpertMenu',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getxTree(xtree) {
        this.xTree = xtree
      },
      async cellClick (row) {
        this.letrec = row.row
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/expert/getExpertMenuTree',
          params: {comid: this.com.comid}
        })
        this.list = res.list
        this.commenus = res.commenus
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'comIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
